{% block sw_sales_channel_detail_theme %}
<mt-card :title="$t('sales-channel-theme.title')" :is-loading="isLoading">
    <div class="sw-sales-channel-detail-theme">

        {% block sw_sales_channel_detail_theme_preview %}
        <div class="sw-sales-channel-detail-theme__preview">
            {% block sw_sales_channel_detail_theme_preview_item %}
            <div @click="openThemeModal">
                <sw-theme-list-item
                    :theme="theme"
                    :disabled="!acl.can('sales_channel.editor')"
                    :active="!!theme"
                />
            </div>
            {% endblock %}

            {% block sw_sales_channel_detail_theme_modal %}
            <sw-theme-modal
                v-if="showThemeSelectionModal"
                :selected-theme-id="theme?.id"
                @modal-theme-select="onChangeTheme"
                @modal-close="closeThemeModal"
            />
            {% endblock %}
        </div>
        {% endblock %}

        {% block sw_sales_channel_detail_theme_info %}
        <div class="sw-sales-channel-detail-theme__info">

            {% block sw_sales_channel_detail_theme_info_content %}
            <div class="sw-sales-channel-detail-theme__info-content">

                {% block sw_sales_channel_detail_theme_info_name %}
                <div class="sw-sales-channel-detail-theme__info-name" :class="{ 'is--empty': !theme }">
                    <span class="sw-sales-channel-detail-theme__info-name-text">
                        {{ theme ? theme.name : $t('sales-channel-theme.defaultTitle') }}
                    </span>

                    {% block sw_sales_channel_detail_theme_info_name_pending %}
                    <span
                        v-if="pendingTheme"
                        v-tooltip="{ message: pendingTooltip, width: 300 }"
                        class="sw-sales-channel-detail-theme__info-pending"
                    >
                        <mt-loader size="16px" />
                    </span>
                    {% endblock %}
                </div>
                {% endblock %}

                {% block sw_sales_channel_detail_theme_info_author %}
                <div v-if="theme" class="sw-sales-channel-detail-theme__info-author">
                    {{ theme.author }}
                </div>
                {% endblock %}

                {% block sw_sales_channel_detail_theme_info_description %}
                <div v-if="theme && theme.description" class="sw-sales-channel-detail-theme__info-description">
                    <p class="sw-sales-channel-detail-theme__info-description-title">
                        {{ $t('sw-theme-manager.detail.description') }}:
                    </p>
                    <p>{{ theme.description |truncate(140) }}</p>
                </div>
                {% endblock %}
            </div>
            {% endblock %}

            {% block sw_sales_channel_detail_theme_info_actions %}
            <div class="sw-sales-channel-detail-theme__info-actions">

                {% block sw_sales_channel_detail_theme_info_actions_theme %}
                <mt-button
                    size="small"
                    :disabled="!acl.can('sales_channel.editor')"
                    variant="secondary"
                    @click="openThemeModal"
                >
                    {{ theme ? $t('sales-channel-theme.changeTheme') : $t('sales-channel-theme.changeThemeEmpty') }}
                </mt-button>
                {% endblock %}

                {% block sw_sales_channel_detail_theme_info_actions_manager %}
                <mt-button
                    size="small"
                    :disabled="!acl.can('sales_channel.editor')"
                    variant="secondary"
                    @click="openInThemeManager"
                >
                    {{ theme ? $t('sales-channel-theme.editContent'): $t('sales-channel-theme.createTheme') }}
                </mt-button>
                {% endblock %}
            </div>
            {% endblock %}
        </div>
        {% endblock %}
    </div>
</mt-card>
{% endblock %}
